module.exports = __webpack_public_path__ + "img/bmw3-3.ca4c69db.png";